import vars from '../_vars';
import {throttle} from './throttle';

const fixFullheight = () => {
	let vh = window.innerHeight * 0.01;
	vars.htmlEl.style.setProperty('--vh', `${vh}px`);
};

let fixHeight = throttle(fixFullheight);

fixHeight();

window.addEventListener('resize', fixHeight);
